module.exports = __webpack_public_path__ + "static/media/img79.66c08cf1.jpg";